(() => {
  const clamp=value=>Math.max(0,Math.min(1,value));
  class Arrival extends HTMLElement {
    connectedCallback(){
      if(this.controller)return;
      this.controller=new AbortController();this.animations=[];
      this.reduced=matchMedia('(prefers-reduced-motion: reduce)');
      const signal=this.controller.signal;
      this.stop=()=>{for(const animation of this.animations)animation.cancel();this.animations=[];};
      for(const event of ['scroll','wheel','touchstart','pointerdown','keydown'])window.addEventListener(event,this.stop,{passive:true,signal});
      this.addEventListener('focusin',this.stop,{signal});
      this.reduced.addEventListener('change',this.stop,{signal});
      Promise.all([customElements.whenDefined('al-hero'),window.__alArrivalReady]).then(([,ready])=>{if(ready!==false&&this.isConnected&&!signal.aborted)this.play();});
    }
    play(){
      if(this.played||this.dataset.enabled!=='true'||this.reduced.matches||location.hash||window.scrollY>100||performance.getEntriesByType('navigation')[0]?.type==='back_forward')return;
      const mobile=matchMedia('(max-width:599px)').matches;
      if(mobile&&this.dataset.mobile!=='true')return;
      this.played=true;
      const hero=this.querySelector('al-hero');
      if(!hero?.querySelector('.atelier-opening.is-enhanced'))return;
      const duration=Number(this.dataset.duration)||1100,travel=(Number(this.dataset.distance)||0)*(mobile?.65:1),stagger=Number(this.dataset.stagger)||0,kind=this.dataset.effect;
      const animate=(el,delay,multiplier=1,opacity=true)=>{
        if(!el?.animate)return;
        const start={},end={};
        if(kind==='rise'){start.translate=`0 ${travel*multiplier}px`;end.translate='0 0';}
        if(kind==='scale'){start.scale=.94;end.scale=1;}
        if(opacity){start.opacity=0;end.opacity=getComputedStyle(el).opacity;}
        this.animations.push(el.animate([start,end],{duration,delay,easing:'cubic-bezier(.22,1,.36,1)',fill:'backwards'}));
      };
      animate(hero.querySelector('.al-wordmark-position'),0,.3);
      hero.querySelectorAll('.atelier-hero__copy>.atelier-kicker,.atelier-hero h1 .atelier-line>*,.atelier-hero__intro').forEach((el,i)=>animate(el,stagger*i,.65));
      hero.querySelectorAll('.atelier-fan__nail').forEach((el,i)=>animate(el,stagger*(i+1),1,false));
      animate(hero.querySelector('.atelier-fan__caption'),stagger*4,.5);
      animate(hero.querySelector('.atelier-opening__lid'),stagger*2,2);
      animate(hero.querySelector('.atelier-hero__foot'),stagger*5,.4);
    }
    disconnectedCallback(){this.stop?.();this.controller?.abort();this.controller=null;}
  }
  class Finale extends HTMLElement {
    connectedCallback(){
      if(this.controller)return;
      this.controller=new AbortController();this.mark=this.querySelector('.al-finale__mark');this.reduced=matchMedia('(prefers-reduced-motion:reduce)');
      const signal=this.controller.signal;
      this.schedule=()=>{if(!this.frame)this.frame=requestAnimationFrame(()=>{this.frame=0;this.render();});};
      window.addEventListener('scroll',this.schedule,{passive:true,signal});window.addEventListener('resize',this.schedule,{passive:true,signal});
      this.reduced.addEventListener('change',this.schedule,{signal});
      this.resize=new ResizeObserver(this.schedule);this.resize.observe(this);this.render();
    }
    render(){
      if(!this.mark)return;
      if(this.dataset.motion!=='true'||this.reduced.matches){this.mark.style.opacity='';this.mark.style.transform='';return;}
      const rect=this.getBoundingClientRect(),vh=window.innerHeight,raw=clamp((vh-rect.top)/Math.max(1,Math.min(vh,rect.height)*(Number(this.dataset.range)||85)/100)),progress=raw*raw*(3-2*raw),opacity=Number(getComputedStyle(this).getPropertyValue('--al-finale-opacity').trim()||1),travel=(Number(this.dataset.travel)||0)*(matchMedia('(max-width:599px)').matches?.6:1);
      this.mark.style.opacity=progress*opacity;
      this.mark.style.transform=this.dataset.effect==='rise'?`translateY(${(1-progress)*travel}px)`:this.dataset.effect==='scale'?`scale(${.94+.06*progress})`:'none';
    }
    disconnectedCallback(){this.controller?.abort();this.resize?.disconnect();if(this.frame)cancelAnimationFrame(this.frame);this.frame=0;this.controller=null;}
  }
  if(!customElements.get('al-arrival'))customElements.define('al-arrival',Arrival);
  if(!customElements.get('al-finale'))customElements.define('al-finale',Finale);
})();
